import { ClearRounded, EditRounded } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { action, API, controller } from "api";
import { Button } from "controls";
import { formatDate } from "hooks";
import { Alert, Dialog, TableActions } from "layout";
import DynamicTable from "layout/DynamicTable/DynamicTable";
import { useEffect, useState } from "react";
import AddEditRole from "./AddEditRole/AddEditRole";
import { toast } from "react-toastify";

const UserRoles = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [updData, setUpdData] = useState();
  const [showForm, setShowForm] = useState(false);
  const [roleList, setRoleList] = useState([]);
  const [tblData, setTblData] = useState([]);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  const handleAddEdit = (val) => {
    setUpdData(val);
    setShowForm(true);
  };

  const handleDlt = (id) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: "Are you sure",
      subTitle: "You want to delete this role?",
      onConfirm: () => {
        const onComplete = (res) => {
          if (res) {
            if (res && res.status === 200) {
              setAlert({
                isOpen: false,
                type: "",
                title: "",
                subTitle: "",
              });
              toast.success(res?.msg);
              setRoleList((x) => [...x.filter((j) => j.id !== res.result.id)]);
            } else toast.error(res?.msg);
          }
        };
        API(controller.UserRole).Delete(id, onComplete);
      },
    });
  };

  useEffect(() => {
    setTblData([
      ...roleList.map((j) => ({
        ...j,
        createDate: formatDate(j.createDate),
        updateDate: formatDate(j.updateDate),
      })),
    ]);
    return () => {};
  }, [roleList]);

  const HeaderComp = () => (
    <Button onClick={handleAddEdit} className="!uppercase">
      Create Role
    </Button>
  );

  const ActionComp = (props) => (
    <TableActions>
      <Tooltip arrow title="Edit">
        <IconButton
          onClick={() => handleAddEdit(props)}
          size="small"
          color="primary"
        >
          <EditRounded className="!text-[18px]" />
        </IconButton>
      </Tooltip>

      <Tooltip arrow title="Delete">
        <IconButton
          onClick={() => handleDlt(props.id)}
          size="small"
          color="error"
        >
          <ClearRounded className="!text-[18px]" />
        </IconButton>
      </Tooltip>
    </TableActions>
  );

  return (
    <>
      <DynamicTable
        key={refreshKey}
        records={tblData}
        setRecords={setRoleList}
        endpointKey={controller.UserRole + action.GetAllByOrg}
        ActionComp={ActionComp}
        HeaderComp={() => <HeaderComp {...{ handleAddEdit }} />}
        headers={[
          { id: "actions", label: "Actions" },
          { id: "title", label: "Title" },
          { id: "subtitle", label: "Subtitle" },
          { id: "createDate", label: "Create Date" },
          { id: "updateDate", label: "Last Update Date" },
        ]}
      />

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />

      {/* Add Edit Form */}
      {showForm && (
        <Dialog show={showForm} onClose={false} maxWidth="md">
          <AddEditRole
            {...{ updData, setShowForm, setTblData, setRefreshKey }}
          />
        </Dialog>
      )}
    </>
  );
};

export default UserRoles;
